import SSO from './SSO';

export default SSO;
